import React from 'react';

const JS_Study_Plan = () => {
  return (
    <div >
      <h1>JS_Study_Plan</h1>
      <p>Placeholder component for: "JS Study Plan"</p>
    </div>
  );
};

export default JS_Study_Plan;
